import moment from 'moment'
import { z } from 'zod'

export const postalCodeRegex = /^\d{4}-\d{3}$/

export const EditInjuredDataSchema = (i18n) =>
	z
		.object({
			name: z.string(),
			birthDate: z.string(),
			profession: z.number(),
			nif: z.number().optional(),
			address: z.string().optional(),
			postalCode: z.string().optional(),
			phoneNumber: z.number(),
			telephone: z.number().optional(),
			email: z.string().email().optional(),
		})
		.superRefine((data, ctx) => {
			const { birthDate, postalCode } = data

			if (!postalCode || postalCode?.match(postalCodeRegex) === null) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: i18n`Postal code is invalid or empty!`,
					path: ['postalCode'],
				})
			}

			if (!moment(birthDate).isValid()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: i18n`Birth date is invalid!`,
					path: ['birthDate'],
				})
			}
		})
